<template>
  <ContentPage back>
    <template #header>
      <div class="pl-2" style="font-size: 20px; font-weight: bold">W9 Request</div>
    </template>

    <Section>
      <v-form ref="form" @submit.prevent="submitClick">
        <BusinessTypeSelect v-model="business_type"/>

        <v-text-field
          outlined dense validate-on-blur
          v-model="ein" label="EIN"
          v-mask="'##-#######'"
          :rules="[required, validEIN]"
        />

        <div class="d-flex" style="position: relative">
          <VueSignaturePad
            ref="signaturePad" 
            height="125px"
            class="rounded"
            style="border: black 1px solid; background-color: #EEEEEE;"
            :options="options"
          />
          <v-icon 
            style="position: absolute; right: 0px;" 
            color="dark grey"
            class="ma-1"
            @click="resetSignature"
          >
            mdi-close-box
          </v-icon>
          <div
            v-if="signatureValid"
            style="font-size: 14px; position: absolute; bottom: 4px; width: 100%"
            class="text-center grey--text font-italic"
          >
            sign here
          </div>
          <div 
            v-else style="font-size: 14px; position: absolute; bottom: 4px; width: 100%"
            class="text-center red--text font-italic"
          >
            signature required
          </div>
        </div>

        <div class="mt-4 d-flex justify-center">
          <v-btn class="ml-3" color="primary" type="submit">Save</v-btn>
        </div>
      </v-form>
    </Section>
  </ContentPage>
</template>

<script>
import { ContentPage, Section } from '@/components/pages'
import BusinessTypeSelect from './BusinessTypeSelect'
import { required } from '@/lib/validations'
import { mapActions, mapGetters } from 'vuex'

export default {
  name :'W9FormPage',

  components: { BusinessTypeSelect, ContentPage, Section },

  data: () => ({
    business_type: '',
    ein: '',

    signatureValid: true,

    options: {
      penColor: 'blue',
    },

    // validations
    required,
    validEIN: v => v.match(/\d\d-\d\d\d\d\d\d\d/) != null || 'expecting ##-#######'
  }),

  computed: {
    ...mapGetters('accounts', ['w9Progress'])
  },

  methods: {
    ...mapActions('accounts', ['createW9', 'saveW9Progress']),

    resetSignature() {
      this.$refs.signaturePad.clearSignature()
    },

    async submitClick() {
      if (this.$refs.signaturePad.isEmpty()) {
        this.signatureValid = false
        this.$refs.form.validate()
        return
      }
      this.signatureValid = true

      if (this.$refs.form.validate()) {
        const { business_type, ein } = this
        const signature = this.$refs.signaturePad.saveSignature().data
        
        const payload = { ...this.w9Progress, business_type, ein, signature }

        const result = await this.createW9(payload)
        if (result.ok) {
          this.saveW9Progress(null)
          this.$router.replace({ name: 'account/w9/thanks' })
        }
      }
    },
  },

  created() {
    if (!this.w9Progress) {
      this.$router.replace({ name: 'account' })
    }
  }
}
</script>

